var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment method icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bitcoin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.87 12.435C24.87 16.8174 21.3174 20.37 16.935 20.37C12.5526 20.37 9 16.8174 9 12.435C9 8.05262 12.5526 4.5 16.935 4.5C21.3174 4.5 24.87 8.05262 24.87 12.435ZM18.8414 9.48687C19.9451 9.86591 20.7526 10.4335 20.5942 11.4897C20.4791 12.2632 20.0488 12.6373 19.4769 12.7682C20.2614 13.1751 20.5288 13.9471 20.2804 14.8807C19.8087 16.2242 18.6874 16.3373 17.1961 16.0565L16.834 17.5008L15.9599 17.2835L16.317 15.8586C16.0904 15.8025 15.8587 15.7425 15.6202 15.6785L15.2615 17.1103L14.3884 16.893L14.75 15.4458L12.9892 15.0033L13.4235 14.0061C13.4235 14.0061 14.0681 14.1762 14.0591 14.1638C14.3067 14.2248 14.4167 14.0641 14.4601 13.9574L15.4413 10.0376C15.4523 9.85251 15.388 9.61933 15.0339 9.53102C15.0473 9.5216 14.3988 9.37375 14.3988 9.37375L14.6314 8.44352L16.3947 8.87862L16.7533 7.4478L17.627 7.6651L17.2758 9.06764C17.5109 9.12073 17.747 9.17481 17.9767 9.23186L18.3253 7.83825L19.1995 8.05555L18.8414 9.48687ZM16.7497 11.8737C17.3452 12.0315 18.6409 12.3751 18.8668 11.4743C19.0972 10.5528 17.8383 10.2745 17.2219 10.1382C17.1521 10.1227 17.0905 10.1091 17.0402 10.0966L16.6049 11.836C16.6464 11.8463 16.6951 11.8592 16.7497 11.8736L16.7497 11.8737ZM16.075 14.6742C16.7882 14.862 18.3481 15.2729 18.5963 14.2804C18.8503 13.2656 17.338 12.9276 16.6 12.7626L16.6 12.7626C16.5175 12.7442 16.4448 12.728 16.3852 12.7131L15.9051 14.6302C15.9538 14.6422 16.0109 14.6573 16.0748 14.6741L16.075 14.6742Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F2F4F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.71089bc30743f0b2f1604a3f893d9349.svg";
export { ForwardRef as ReactComponent };